import React, { useContext, useState } from 'react';
import { Button, TextField } from '@material-ui/core';
import { MultiStepContext } from '../StepContext6';

export default function Questions6() {
    const { setStep, blogerData, setBlogerData, blogersubmitData } = useContext(MultiStepContext);
    const [error, setError] = useState(null);

    const handleSubmit = () => {
        if (!blogerData.ans1 || !blogerData.ans2 || !blogerData.ans3) {
            setError("Please fill in all fields.");
        } else {
            setError(null);
            blogersubmitData();
        }
    };

    return (
        <div>
            <h4 style={{textAlign:'center'}}>Security Questions</h4>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Primary School Name"
                margin='normal'
                value={blogerData['ans1'] || ''}
                onChange={(e) => setBlogerData({ ...blogerData, "ans1": e.target.value })}
                variant='outlined'
            />
            </div>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Favourite Food"
                margin='normal'
                value={blogerData['ans2'] || ''}
                onChange={(e) => setBlogerData({ ...blogerData, "ans2": e.target.value })}
                variant='outlined'
            />
            </div>
            <div className="flx-adrs"> 
            <TextField
                style={{width:'100%'}}
                label="Your Best Friend Name"
                margin='normal'
                value={blogerData['ans3'] || ''}
                onChange={(e) => setBlogerData({ ...blogerData, "ans3": e.target.value })}
                variant='outlined'
            />
            </div>
            {error && <p style={{color: 'red'}}>{error}</p>}
            <div className="signupbtnn">  
                <Button variant='contained' onClick={() => setStep(1)} color='secondary'>Back</Button>
                <Button variant='contained' style={{float:'right'}} onClick={handleSubmit} color='primary'>Submit</Button> 
            </div>    
        </div>
    );
}
